import { useEffect, useState } from 'react'
import { useAudioRecorder } from 'react-audio-voice-recorder'
import Controls from './Controls'
import { useStreamerConfigContext } from '@/contexts/StreamerConfigContext/StreamerConfigContext'

type Props = {
  onSetAudio: (value: Blob | null) => void
}

export default function Recording({ onSetAudio }: Props) {
  const { config } = useStreamerConfigContext()
  const maxDurationSeconds = config?.audio_donation_config?.max_duration_seconds
  const [recordingUrl, setRecordingUrl] = useState<string>()
  const [recordingLength, setRecordingLength] = useState<number>()
  const [isBlocked, setBlocked] = useState(false)

  const { startRecording, stopRecording, recordingBlob, isRecording, recordingTime } = useAudioRecorder(
    {},
    () => setBlocked(true),
    {
      mimeType: 'audio/webm',
    }
  )

  const handleStopRecording = () => {
    setRecordingLength(recordingTime)
    stopRecording()
  }

  const handleDeleteRecording = () => {
    onSetAudio(null)
    setRecordingUrl(undefined)
    setRecordingLength(undefined)
  }

  useEffect(() => {
    if (!recordingBlob) {
      return
    }

    const url = URL.createObjectURL(recordingBlob)
    setRecordingUrl(url)
    onSetAudio(recordingBlob)

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [recordingBlob])

  useEffect(() => {
    if (maxDurationSeconds && maxDurationSeconds === recordingTime) {
      handleStopRecording()
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [maxDurationSeconds, recordingTime])

  return (
    <Controls
      isRecorded={recordingUrl != null}
      isRecording={isRecording}
      onStop={handleStopRecording}
      onStart={startRecording}
      maxDuration={maxDurationSeconds}
      recordingLength={recordingLength}
      recordingTime={recordingTime}
      onDelete={handleDeleteRecording}
      isBlocked={isBlocked}
      audioSrc={recordingUrl}
    />
  )
}
